import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE = 'https://lidaventerprises.com';
const LOGO = `${BASE}/images/logo.jpg`;

export default function PageSEO({ title, description, canonical, schema }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${BASE}${canonical}`} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${BASE}${canonical}`} />
      <meta property="og:image" content={LOGO} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Lidav Enterprises Limited" />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={LOGO} />

      {/* Per-page JSON-LD */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
